import { FC } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import Main from './pages/Main';

const CheaperPrice: FC = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={`${path}`} component={Main} />
    </Switch>
  );
};

export default CheaperPrice;
